var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaiting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sign",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32.128,
    viewBox: "0 0 32 32.128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_17",
    "data-name": "Union 17",
    d: "M1.244,30.217A1.358,1.358,0,0,1,0,28.75,38.382,38.382,0,0,1,3.09,17.622a35.552,35.552,0,0,1,5.9-9.317A30.961,30.961,0,0,1,19.67.512l.2-.085c.333-.143.574-.247.789-.317a1.632,1.632,0,0,1,1.509.158,1.844,1.844,0,0,1,.64,1.8c0,.068-.008.143-.012.225V2.3a44.025,44.025,0,0,1-.485,4.627,1.377,1.377,0,0,1-.021.143l-.009.044c-1.046,6.29-3.469,11.091-7.235,14.309A17.923,17.923,0,0,1,3.287,25.652a27.525,27.525,0,0,0-.576,3.326A1.357,1.357,0,0,1,1.36,30.222Q1.3,30.222,1.244,30.217Zm4.332-11.5a38.228,38.228,0,0,0-1.562,4.212,15.481,15.481,0,0,0,2.322-.265,14.823,14.823,0,0,0,6.98-3.329c.078-.067.156-.136.233-.2-.239.016-.486.025-.739.025a10.182,10.182,0,0,1-2.35-.268,1.358,1.358,0,0,1,.626-2.643,8.869,8.869,0,0,0,5.154-.493l.056-.024q.063-.026.128-.045a20.7,20.7,0,0,0,1.979-4.2,9.433,9.433,0,0,1-2.412.594,1.358,1.358,0,0,1-.314-2.7c1.027-.119,3.451-.63,3.937-2.782q.255-1.554.39-3.247A29.531,29.531,0,0,0,5.576,18.716Z",
    transform: "translate(4.462 1.406)",
    fill: "#ae60ff",
    stroke: "#3a3f64",
    strokeLinecap: "round",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.0eb12807.svg";
export { ForwardRef as ReactComponent };